import React from 'react';

const portfolioItems = [
    {
        image: 'https://picsum.photos/600/400?random=1',
        title: 'E-commerce Website',
        category: 'Web Development'
    },
    {
        image: 'https://picsum.photos/600/400?random=2',
        title: 'Fitness Tracking App',
        category: 'Mobile App'
    },
    {
        image: 'https://picsum.photos/600/400?random=3',
        title: 'Customer Service Bot',
        category: 'Telegram Bot'
    },
    {
        image: 'https://picsum.photos/600/400?random=4',
        title: 'Portfolio Website',
        category: 'Web Development'
    },
    {
        image: 'https://picsum.photos/600/400?random=5',
        title: 'Task Management App',
        category: 'Mobile App'
    },
    {
        image: 'https://picsum.photos/600/400?random=6',
        title: 'Blog Platform',
        category: 'Web Development'
    },
    {
        image: 'https://picsum.photos/600/400?random=7',
        title: 'Recipe Sharing App',
        category: 'Mobile App'
    },
    {
        image: 'https://picsum.photos/600/400?random=8',
        title: 'Real Estate Management System',
        category: 'Web Development'
    },
    {
        image: 'https://picsum.photos/600/400?random=9',
        title: 'Online Learning Platform',
        category: 'Web Development'
    },
    {
        image: 'https://picsum.photos/600/400?random=10',
        title: 'Chat Application',
        category: 'Web Development'
    }
];



function Portfolio() {
    return (
        <section id="portfolio" className="py-20 bg-gray-100">
            <div className="container mx-auto px-4">
                <h2 className="text-4xl font-bold text-center mb-12 text-gray-800">Our Portfolio</h2>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {portfolioItems.map((item, index) => (
                        <div key={index} className="portfolio-item rounded-lg overflow-hidden shadow-lg">
                            <img src={item.image} alt={item.title} className="w-full h-64 object-cover" />
                            <div className="portfolio-overlay">
                                <h3 className="text-2xl font-bold text-white mb-2">{item.title}</h3>
                                <p className="text-lg text-white opacity-75">{item.category}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default Portfolio;